import {chakra} from '@chakra-ui/react';
import {AgentType} from '../../../shared/agent';
import {Events, SearchLocate, WordCloud, ZoomArea} from '@carbon/icons-react';
import {useIsKeyplayAdmin} from '../../../hooks/api/user';
import {entries} from '../../../shared/util';

export const AgentTypeInfo: Record<
  AgentType,
  {
    description: string;
    icon: React.ElementType;
    status: 'beta' | 'stable' | 'legacy';
  }
> = {
  // Note: The order of these types determines the order of the cards in the
  // agent builder and on the agents home page.
  legacyResearchAndAnalyst: {
    description:
      'Agent conducts online research and creates structured outputs.',
    icon: chakra(ZoomArea),
    status: 'legacy',
  },
  researchAndAnalyst: {
    description:
      'Agent conducts online research and creates structured outputs.',
    icon: chakra(ZoomArea),
    status: 'beta',
  },
  analyst: {
    description:
      'Agent assesses Keyplay account research & data fields to create structured outputs.',
    icon: chakra(SearchLocate),
    status: 'stable',
  },
  legacyResearch: {
    description:
      'AI research agent searches the web and returns a summary of findings for each account.',
    icon: chakra(WordCloud),
    status: 'legacy',
  },
  research: {
    description:
      'AI research agent searches the web and returns a summary of findings for each account.',
    icon: chakra(WordCloud),
    status: 'beta',
  },
  legacyTeamSize: {
    description: 'Agent estimates the size of a specific team.',
    icon: chakra(Events),
    status: 'legacy',
  },
  teamSize: {
    description: 'Agent estimates the size of a specific team.',
    icon: chakra(Events),
    status: 'stable',
  },
};

export const useAvailableAgentTypes = ({
  currentType,
  filter = 'all',
}: {
  currentType?: AgentType;
  filter?: 'all' | 'stable';
}) => {
  const isKeyplayAdmin = useIsKeyplayAdmin();
  return (
    entries(AgentTypeInfo)
      // legacy agents are only available if they are the current type
      .filter(([type, {status}]) => status !== 'legacy' || currentType === type)
      // filter out beta agents
      .filter(
        ([, {status}]) =>
          status === 'stable' || (filter === 'all' && isKeyplayAdmin)
      )
      .map(([type]) => type)
  );
};
